import ProbeDataService from '../../service/ProbeDataService'
import moment from 'moment'

const newLocation = {
    longitude: null,
    latitude: null,
    date: moment().format('YYYY-MM-DD'),
}

const initialState = {
    loading: false,
    probes: [],
    probesList: [],
    probesCount: 0,
    totalProbes: 0,
    activeProbe: null,
    activeStations: [],
    newLocation: { ...newLocation },
    queryStatus: 'all',
    stateQuery: 'all',
    countriesQuery: 'all',
    probeSensorMeasurements: [],
    selectedSensorMeasurements: {},
    deleteMeasurements: [],
    companies: [],
    percoModal: false,
    regionModal: false,
    mergeStationModal: false,
    tableOptions: null,
    searchString: '',
    seasons: [],
    tillageMethods: [],
    sectors: []
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async fetchProbeList({ commit, state }) {
            try {
                let params = {
                    search: state.searchString,
                    page: state.tableOptions && state.tableOptions.page ? state.tableOptions.page : null,
                    itemsPerPage:
                        state.tableOptions && state.tableOptions.itemsPerPage ? state.tableOptions.itemsPerPage : null,
                    status: state.queryStatus ?? null,
                    state: state.stateQuery ?? null,
                    countries: state.countriesQuery ?? null,
                }
                commit('setLoading', true)
                let resp = await ProbeDataService.getAll(params)
                if (resp.status === 200) {
                    commit('setProbesList', resp?.data?.probes)
                    commit('setProbesCount', resp?.data?.probes_count)
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async fetchProbe({ commit }, id) {
            try {
                commit('setLoading', true)

                const resp = await ProbeDataService.get(id)

                if (resp.status === 200) {
                    const activeStation = resp.data.find(s => s.id === parseInt(id))

                    commit('setActiveProbe', activeStation)
                    commit('setActiveStations', resp.data)
                }

                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },

        async toggleProbeUseForMap({ commit, dispatch }, { itemId, value }) {
            try {
                commit('setLoading', true)
                const data = { value }
                const resp = await ProbeDataService.updateProbeUseForMapLayers(itemId, data)
                if (resp.status === 200) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Use for map layers data updated!',
                            type: 'success',
                        },
                        { root: true }
                    )
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Update failed (use for map layers)!',
                            type: 'error',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async fetchProbeSensorMeasurements({ commit, state }, data) {
            const { sensorId, date } = data
            try {
                commit('setLoading', true)
                commit('setProbeSensorMeasurements', [])
                const resp = await ProbeDataService.getProbeSensorMeasurements(state.activeProbe.id, sensorId, date)

                if (resp.status === 200) {
                    commit('setProbeSensorMeasurements', resp.data)
                }

                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async updateProbe({ state, commit, dispatch }) {
            try {
                commit('setLoading', true)
                const resp = await ProbeDataService.update(state.activeProbe)

                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Station data updated!',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async updateSensor({ state, commit, dispatch }, sensor) {
            try {
                commit('setLoading', true)
                const resp = await ProbeDataService.updateSensor(state.activeProbe.id, sensor)

                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Sensor data updated!',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async createLocation({ state, commit, dispatch }) {
            try {
                commit('setLoading', true)

                const resp = await ProbeDataService.createProbeLocation(state.activeProbe.id, state.newLocation)

                if (resp.status === 201) {
                    commit('resetNewLocation')
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Sensor data updated!',
                            type: 'success',
                        },
                        { root: true }
                    )
                    dispatch('fetchProbe', state.activeProbe.id)
                } else {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async duplicateLocation({ state, commit, dispatch }, payload) {
            const { activeProbeId, locationId } = payload
            try {
                commit('setLoading', true)
                const resp = await ProbeDataService.duplicateProbeLocation(activeProbeId, locationId)

                if (resp.status === 201) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Location duplicated!',
                            type: 'success',
                        },
                        { root: true }
                    )
                    if (resp?.data.duplicate_probe_location) {
                        location.end_date = resp.data.previous_location_end_date
                        if (state.activeProbe) {
                            commit('addLocationToActiveProbe', {
                                duplicatedLocation: resp.data.duplicate_probe_location,
                            })
                        } else {
                            return resp.data.duplicate_probe_location
                        }
                    }
                } else {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async updateProbeLocation({ commit, dispatch }, payload) {
            const { probeId, location } = payload
            try {
                commit('setLoading', true)
                const resp = await ProbeDataService.updateProbeLocation(probeId, location.id, location)
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Location updated',
                            type: 'success',
                        },
                        { root: true }
                    )
                    commit('setProbeAlias', resp.data)
                } else {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', true)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async recalculateNo3({ commit, dispatch }, payload) {
            const { probeId, locationId } = payload
            try {
                commit('setLoading', true)
                const resp = await ProbeDataService.recalculateNo3(probeId, locationId)
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Successfully recalculated NO3 values',
                            type: 'success',
                        },
                        { root: true }
                    )
                } else {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async removeProbeLocation({ commit, dispatch }, payload) {
            const { probeId, locationId } = payload
            try {
                commit('setLoading', true)
                const resp = await ProbeDataService.removeProbeLocation(probeId, locationId)
                if (resp.status === 200) {
                    window.location.reload()
                } else {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async deleteProbeState({ commit, dispatch }, stateId) {
            try {
                const resp = await ProbeDataService.deleteProbeState(stateId)

                if (resp.status === 204) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Station state deleted!',
                            type: 'success',
                        },
                        { root: true }
                    )
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async clearSensorMeasurements({ commit, dispatch, state }, data) {
            const { sensorId } = data
            try {
                commit('setLoading', true)
                const resp = await ProbeDataService.deleteProbeSensorMeasurements(
                    state.activeProbe.id,
                    sensorId,
                    state.selectedSensorMeasurements,
                    state.deleteMeasurements
                )

                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.data.message,
                            type: 'success',
                        },
                        { root: true }
                    )
                    dispatch('fetchProbeSensorMeasurements', data)
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async fetchLocationCompany({ commit }) {
            try {
                let resp = await ProbeDataService.getLocationCompanies()
                if (resp.status === 200) {
                    commit('setCompanies', resp.data)
                }
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async fetchProbePercoData({ commit, dispatch }, payload) {
            try {
                let resp = await ProbeDataService.updateProbePercoMeasurements(payload.probe_id, payload)
                if (resp.status === 200) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.data.message,
                            type: 'success',
                        },
                        { root: true }
                    )
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.data.message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async addProbeRegion({ commit, dispatch }, payload) {
            try {
                let resp = await ProbeDataService.addProbeRegion(payload.probe_id, payload)
                if (resp.status === 200) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.data.message,
                            type: 'success',
                        },
                        { root: true }
                    )
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: resp.data.message,
                            type: 'error',
                        },
                        { root: true }
                    )
                }
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async mergeStations({ commit, dispatch }, payload) {
            try {
                let resp = await ProbeDataService.mergeStations(payload.station_id, payload)
                let message = resp.data.message || 'Merging stations failed!';
                let snackbarType = 'error';

                if (resp.status === 200) {
                    snackbarType = 'success'
                } else {
                    snackbarType = 'error'
                }

                await dispatch(
                    'app/showSnackbar',
                    {
                        bool: true,
                        message: message,
                        type: snackbarType,
                    },
                    {root: true},
                );
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async fetchSeasons({ commit }) {
            try {
                let resp = await ProbeDataService.getSeasons()
                if (resp.status === 200) {
                    commit('setSeasons', resp.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async fetchTillageMethods({ commit }) {
            try {
                let resp = await ProbeDataService.getTillageMethods()
                if (resp.status === 200) {
                    commit('setTillageMethods', resp.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async fetchSectors({ commit }) {
            try {
                let resp = await ProbeDataService.getSectors()
                if (resp.status === 200) {
                    commit('setSectors', resp.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
    },
    mutations: {
        setProbeAlias(state, data) {
            if (data?.alias) {
                state.activeProbe.alias = data.alias
                state.activeProbe.long_alias = data.long_alias
            }
        },
        setProbes(state, probes) {
            state.probes = probes
        },
        setProbesList(state, probes) {
            state.probesList = probes
        },
        setActiveProbe(state, data) {
            state.activeProbe = {
                ...data,
                is_active: !!data.is_active,
                sensors: data.sensors.map(s => ({ ...s, is_active: !!s.is_active, has_error: !!s.has_error })),
            }
        },
        setActiveStations(state, data) {
            state.activeStations = data.map(s => {
                return {
                    ...s,
                    is_active: !!s.is_active,
                    sensors: s.sensors.map(sensor => ({
                        ...sensor,
                        is_active: !!sensor.is_active,
                        has_error: !!sensor.has_error,
                    })),
                }
            })
        },
        addLocationToActiveProbe(state, data) {
            state.activeProbe = {
                ...state.activeProbe,
                locations: [...state.activeProbe.locations, data.duplicatedLocation],
            }
        },
        setLoading(state, bool) {
            state.loading = bool
        },
        setCompanies(state, data) {
            state.companies = data
        },
        setSearchString(state, data) {
            state.searchString = data
        },
        setTableOptions(state, data) {
            state.tableOptions = data
            this.dispatch('probe/fetchProbeList')
        },
        setQueryStatus(state, data) {
            state.queryStatus = data
        },
        setStateQuery(state, data) {
            state.stateQuery = data
        },
        setCountriesQuery(state, data) {
            state.countriesQuery = data
        },
        setProbeSensorMeasurements(state, measurements) {
            state.probeSensorMeasurements = measurements
        },
        resetNewLocation(state) {
            state.newLocation = { ...newLocation }
        },
        setPercoModal(state, value) {
            state.percoModal = value
        },
        setRegionModal(state, value) {
            state.regionModal = value
        },
        setMergeStationModal(state, value) {
            state.mergeStationModal = value
        },
        setProbesCount(state, value) {
            state.probesCount = value
        },
        setDeleteMeasurements(state, value) {
            if (!state.deleteMeasurements.includes(value)) {
                state.deleteMeasurements.push(value)
            } else {
                console.log(state.deleteMeasurements)
                state.deleteMeasurements = state.deleteMeasurements.filter(dm => dm !== value)
            }
        },
        setSelectedSensorMeasurements(state, { index, value }) {
            state.selectedSensorMeasurements = {
                ...state.selectedSensorMeasurements,
                [index]: value,
            }
        },
        modifySelectedSensorMeasurements(state, payload) {
            const { id, type } = payload

            if (state.selectedSensorMeasurements[id]) {
                if (state.selectedSensorMeasurements[id].includes(type)) {
                    if (state.selectedSensorMeasurements[id].length <= 1) {
                        delete state.selectedSensorMeasurements[id]
                        state.selectedSensorMeasurements = {
                            ...state.selectedSensorMeasurements,
                        }
                        return
                    }
                    state.selectedSensorMeasurements = {
                        ...state.selectedSensorMeasurements,
                        [id]: state.selectedSensorMeasurements[id].filter(m => m !== type),
                    }
                } else {
                    state.selectedSensorMeasurements = {
                        ...state.selectedSensorMeasurements,
                        [id]: [...state.selectedSensorMeasurements[id], type],
                    }
                }
            } else {
                state.selectedSensorMeasurements = {
                    ...state.selectedSensorMeasurements,
                    [id]: [type],
                }
            }
        },
        setSeasons(state, data) {
            state.seasons = data
        },

        setTillageMethods(state, data) {
            state.tillageMethods = data
        },

        setSectors(state, data) {
            state.sectors = data
        },
    },
}
